import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { updateIsShow, updateMessage, updateAfterEvent, updateAfterPath, updateIsPromotion } from '@Root/slices/myhouse/toast'
import { RootState } from '@Root/slices'
import { TOAST_AFTER_EVENT } from '@Root/contants/myhouseToast'

export default function useToast() {
  const dispatch = useDispatch()

  const toast = useSelector((state: RootState) => state.myhouseToast)

  const show = useCallback(
    (message: string, afterEvent?: TOAST_AFTER_EVENT, path?: string, isPromotion?: boolean) => {
      dispatch(updateMessage(message))
      dispatch(updateAfterEvent(afterEvent || TOAST_AFTER_EVENT.NONE))
      dispatch(updateAfterPath(path || ''))
      dispatch(updateIsShow(true))
      /*무료보험 프로모션 추가부분 시작*/
      dispatch(updateIsPromotion(isPromotion || false))
      /*무료보험 프로모션 추가부분 끝*/
    },
    [dispatch],
  )

  const hide = useCallback(() => {
    dispatch(updateIsShow(false))
    dispatch(updateMessage(''))
    /*무료보험 프로모션 추가부분 시작*/
    dispatch(updateIsPromotion(false))
    /*무료보험 프로모션 추가부분 끝*/
  }, [dispatch])

  return { toast, show, hide }
}
